import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Tooltip from "@tippyjs/react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ContentLoader from "react-content-loader";
import "tippy.js/dist/tippy.css";

import Helper from "../../../../Helper";
import GetCompanyInfoService from "../../../../services/company/getCompanyInfoService";
import PartyShortdetilview from "./partyquickview";
import Partycontact from "../contact/Party-contact";
import ContactEdit from "../contact/ContactEdit";
import ManageNotification from "../notifications/ManageNotification";
import ContractList from "../../../../components/contractList/index";
import AddresstList from "../../../../components/addressList/index";
import ContactList from "../../../../components/contactList/index";
import DetailsPartyService from "../../../../services/party/detailsparty";
import { getTrans as t } from "../../../../Localization/translations";
import AddNotification from "../notifications/AddNotification";
import EditNotification from "../notifications/EditNotification";
import Doc from "../../../UploadDocument/doc";
import DocumentUpload from "../../../../services/document/documentupload";
import AchIndex from "../achAccount";
import AddAchAccounts from "../achAccount/achAdd";
import EditAchAccount from "../achAccount/achEdit";

function PartyDetails({ setCustomData, setNotesLength, customerPermission }) {
  const [party_type, setParty_type] = useState("");
  const [customer_type, setCustomer_type] = useState("");
  const [customer_name, setCustomer_name] = useState("");
  const [partyref, setPartyRef] = useState("");
  const [company_name, setCompany_name] = useState("");
  const [sales_tax_code, setSales_tax_code] = useState("");
  const [TIN_number, setTIN_number] = useState("");
  const [website, setWebsite] = useState("");
  const [prefix, setPrefix] = useState("");
  const [first_name, setFirst_name] = useState("");
  const [middle_name, setMiddle_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [ssn_tin_number, setSsn_tin_number] = useState("");
  const [id_issue_state, setId_issue_state] = useState("");
  const [date_of_birth, setDate_of_birth] = useState("");
  const [total_billed_not_paid, setTotal_Billed_Not_Paid] = useState(0);
  const [total_capital_recovery, setTotal_Capital_Recovery] = useState(0);
  const [establishment_date, setEstablishmnet] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [activecontractno, setActiveContractNo] = useState(0);
  const [loading, setLoading] = useState(true);
  const [extrafiledparty, setExtraFiled] = useState([]);
  const [attribute, setAttribute] = useState([]);
  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );
  const [hideShowParyContact, setHideShowParyContact] = useState(false);
  const [hideShowParyContactEdit, setHideShowParyContactEdit] = useState(false);
  const [hideShowNotify, setHideShowNotify] = useState(false);
  const [hideShowNotifyEdit, setHideShowNotifyEdit] = useState(false);
  const [contactId, setContactId] = useState("");
  const [notifyId, setNotifyId] = useState("");
  const [amount_due, setAmount_due] = useState(null);
  const [days_past_due, setDays_past_due] = useState(null);
  const permissionsArray = permissionss.split(",");
  const [hideShowachindex, setHideShowAchIndex] = useState(false);
  const [hideShowachedit, setHideShowAchEdit] = useState(false);
  const [hideShowachId, setHideShowAchID] = useState("");
  const isCustomer = party_type.includes('Customer');

  const [object_name, setObject_name] = useState("Parties");
  const [pre_bill_days, setpre_bill_days] = useState(null);
  const [consolidate_invoice, setConsolidate_invoice] = useState(null);
  const [generate_Invoice, setGenerate_Invoice] = useState(null);
  const [doingbusinessas, setDoingBusinessAs] = useState("");
  const [business_type, setBusinessType] = useState("");
  const [federalID, setFederalID] = useState("");
  const [sic, setSIC] = useState("");
  const [naics, setNAICS] = useState("");
  const [riskrating, setRiskRating] = useState("");
  const [creditscore, setCreditScore] = useState("");
  const [achPayments, setAchPayments] = useState(false);
  const [achId, setACHId] = useState(null);

  const { state } = useLocation();
  const navigate = useNavigate();

  const getExtrafiled = () => {
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiled(response.data.existparty);
    });
  };
  const handleClick = (index) => {
    setTabIndex(index);
  };

  useEffect(() => {
    getExtrafiled();
    DetailsPartyService.getPartyDetails(state).then((response) => {
      setParty_type(response.data.party_type);
      setCustomer_type(response.data.customer_type);
      setCustomer_name(response.data.customer_name);
      setPartyRef(response.data.party_ref);
      setTIN_number(response.data.TIN_number);
      setEstablishmnet(response.data.establishment_date);
      setSales_tax_code(response.data.sales_tax_code);
      setWebsite(response.data.website);
      setPrefix(response.data.prefix);
      setFirst_name(response.data.first_name);
      setMiddle_name(response.data.middle_name);
      setLast_name(response.data.last_name);
      setSsn_tin_number(response.data.ssn_tin_number);
      setId_issue_state(response.data.id_issue_state);
      setDate_of_birth(response.data.date_of_birth);
      setNotesLength(response.data.has_notes);
      setCompany_name(response.data.company.company_name);
      setTotal_Capital_Recovery(
        response.data.customer_exposure.outstanding_capital_recovery
      );
      setTotal_Billed_Not_Paid(
        response.data.customer_exposure.total_billed_not_paid
      );
      setActiveContractNo(
        response.data.customer_exposure.active_contract_count
      );
      setpre_bill_days(response.data.pre_bill_days);
      setConsolidate_invoice(response.data.consolidate_invoice);
      setGenerate_Invoice(response.data.generate_invoice);
      setDays_past_due(response.data.days_past_due);
      setAmount_due(response.data.amount_due);
      setDoingBusinessAs(response.data.doingBusinessAs);
      setBusinessType(response.data.business_type);
      setFederalID(response.data.federalID);
      setSIC(response.data.SIC);
      setNAICS(response.data.NAICS);
      setRiskRating(response.data.riskrating);
      setCreditScore(response.data.creditscore);
      setAchPayments(response.data.ACHPayments);

      setAttribute([
        { attribute: response.data.attribute1 },
        { attribute: response.data.attribute2 },
        { attribute: response.data.attribute3 },
        { attribute: response.data.attribute4 },
        { attribute: response.data.attribute5 },
        { attribute: response.data.attribute6 },
        { attribute: response.data.attribute7 },
        { attribute: response.data.attribute8 },
        { attribute: response.data.attribute9 },
        { attribute: response.data.attribute10 },
        { attribute: response.data.attribute11 },
        { attribute: response.data.attribute12 },
        { attribute: response.data.attribute13 },
        { attribute: response.data.attribute14 },
        { attribute: response.data.attribute15 },
      ]);
      setLoading(false);
    });
  }, [state]);

  useEffect(() => {
    setCustomData({
      object_id: state,
      object_name: object_name,
    });
  }, [object_name, setCustomData, state]);

  const addFormRef = useRef(null);
  const editFormRef = useRef(null);
  const addfromcontract = useRef(null);
  const editformcontract = useRef(null);

  const addfromAch = useRef(null);
  const editformAch = useRef(null);

  useEffect(() => {
    if (hideShowNotify && addFormRef.current) {
      addFormRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [hideShowNotify]);

  useEffect(() => {
    if (hideShowParyContact && addfromcontract.current) {
      addfromcontract.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [hideShowParyContact]);

  useEffect(() => {
    if (hideShowParyContactEdit && editformcontract.current) {
      editformcontract.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [hideShowParyContactEdit]);

  useEffect(() => {
    if (hideShowNotifyEdit && editFormRef.current) {
      editFormRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [hideShowNotifyEdit]);

  const [currentPage, setCurrentPage] = useState(1);
  const [documents, setDocuments] = useState([]);

  const recordsPerPage = 2;

  let indexOfLastRecord, indexOfFirstRecord, currentDocuments, totalPages;
  if (customerPermission !== "Customer") {
    indexOfLastRecord = currentPage * recordsPerPage;
    indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    currentDocuments = documents.slice(indexOfFirstRecord, indexOfLastRecord);
    totalPages = Math.ceil(documents.length / recordsPerPage);
  } else {
    currentDocuments = documents;
  }

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  useEffect(() => {
    DocumentUpload.viewListuploadFilterview(customer_name, state)
      .then((res) => {
        setDocuments(res.data.data);
      })
      .catch((e) => {
        console.log("e", e);
      });
  }, [customer_name, state]);

  const handleDownload = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleUpload = () => {
    navigate("/doc", {
      state: {
        reference_id: state,
        reference_name: customer_name,
      },
    });
  };
  return (
    <>
      <div className="container-fluid py-4">
        {loading === false ? (
          <>
            <div className="row ">
              <div className="col-md-2">
                <div className="header pb-0 mb-3">
                  <h5 style={{ color: "#000000" }}>{t("Party")}</h5>
                  <h6>
                    <Link to="/party" className="tc">
                      {t("Parties")}
                    </Link>{" "}
                    /{" "}
                    <span style={{ color: "#000000" }}>{t("View Party")}</span>
                  </h6>
                </div>
              </div>
            </div>

            <Tabs
              selectedIndex={tabIndex}
              onSelect={(index) => handleClick(index)}
            >
              <TabList>
                <Tab>
                  <p>{t("Party Details")}</p>
                </Tab>
                {party_type.includes("Customer") ? (
                  // achPayments === true ?
                  <>
                    <Tab>
                      <p>{t("Bank Accounts")}</p>
                    </Tab>
                  </>

                ) :
                  ""
                }
                <Tab>
                  <p>{t("Manage Address")}</p>
                </Tab>
                <Tab>
                  <p>{t("Manage Contacts")}</p>
                </Tab>
                {party_type.includes("Customer") ? (
                  <>
                    <Tab>
                      <p>{t("Manage Notifications")} </p>
                    </Tab>
                    {permissionss &&
                      permissionsArray.includes("view_contract") === true ? (
                      <Tab>
                        <p>{t("View Contracts")}</p>
                      </Tab>
                    ) : null}
                  </>
                ) : (
                  ""
                )}
                
              </TabList>

              <TabPanel>
                <div
                  className="panel-content pa-co"
                  style={{ paddingLeft: "10px" }}
                >
                  <div className="row">
                    <div className="col-md-12">
                      <div className="header pb-0 mb-3 d-flex align-items-center justify-content-between">
                        <h5> {t("Party Details")}</h5>
                      </div>
                      <div className="d-flex flex-column flex-lg-row">
                        <div className="col-12 col-lg-7">
                          <div className="card h-100">
                            <div className="card-body">
                              <div className="task-infos">
                                <div className="row  g-3">
                                  <div className="col-12">
                                    <div className="row">
                                      <div className="col-md-6 mb-2 mb-md-0">
                                        <div className="d-flex justify-content-between">
                                          <span className="sub-title tc tc">
                                            {t("Party Type")}{" "}
                                            <Tooltip
                                              content={t("PartyType_Tooltip")}
                                            >
                                              <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                          </span>
                                          <span className="party-detail-font ">
                                            {party_type}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="col-md-6 mb-2 mb-md-0">
                                        <div className="d-flex justify-content-between">
                                          <span className="sub-title tc">
                                            {t("Entity Type")}{" "}
                                            <Tooltip
                                              content={t("EntityType_Tooltip")}
                                            >
                                              <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>{" "}
                                          </span>
                                          <span className="party-detail-font ">
                                            {customer_type}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="row">
                                    <div className="col-md-6 mb-2 mb-md-0">
                                      <div className="d-flex justify-content-between">
                                        <span className="sub-title tc">
                                          {t("Party Name")}{" "}
                                          <Tooltip
                                            content={t("PartyName_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </span>
                                        <span className="party-detail-font ">
                                          {customer_name}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="col-md-6 mb-2 mb-md-0">
                                      <div className="d-flex justify-content-between">
                                        <span className="sub-title tc">
                                          {t("Party Ref")}{" "}
                                          <Tooltip
                                            content={t("PartyName_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </span>
                                        <span className="party-detail-font ">
                                          {partyref !== "null"
                                            ? partyref
                                            : "None"}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {isCustomer &&(
                              <div className="col-12">
                                <div className="row">
                                  <div className="col-md-6 mb-2 mb-md-0">
                                    <div className="d-flex justify-content-between">
                                      <span className="sub-title tc">
                                        {t("Customer Exposure")}{" "}
                                        <Tooltip
                                          content={t(
                                            "Customer_Exposure_Tooltip"
                                          )}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </span>
                                      <span className="party-detail-font ">
                                        {Helper.Amount(
                                          total_billed_not_paid +
                                            total_capital_recovery
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-md-6 mb-2 mb-md-0">
                                    <div className="d-flex justify-content-between">
                                      <span className="sub-title tc">
                                        {t("Active Contracts")}{" "}
                                        <Tooltip
                                          content={t(
                                            "Active_contracts_Tooltip"
                                          )}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </span>
                                      <span className="party-detail-font ">
                                        {activecontractno}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              )}
                              {isCustomer &&(
                              <div className="col-12">
                                <div className="row">
                                  <div className="col-md-6 mb-2 mb-md-0">
                                    <div className="d-flex justify-content-between">
                                      <span className="sub-title tc">
                                        {t("Amount Due")}{" "}
                                        <Tooltip content={t("Amount Due")}>
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </span>
                                      <span className="party-detail-font ">
                                        {amount_due &&
                                          Helper.Amount(amount_due)}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-md-6 mb-2 mb-md-0">
                                    <div className="d-flex justify-content-between">
                                      <span className="sub-title tc">
                                        {t("Days Past Due")}{" "}
                                        <Tooltip
                                          content={t("DaysPastDue_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </span>
                                      <span className="party-detail-font ">
                                        {days_past_due && days_past_due}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              )}
                              <div className="col-12">
                                <div className="row">
                                  {/* <div className="col-md-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <span className='sub-title tc' >{t('Consolidate Invoice')} <Tooltip content={t('Consolidate invoice_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></span>
                                <div className="col-md-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                  <span className="party-detail-font " >

                                    {consolidate_invoice}
                                  </span>
                                </div>
                              </div> */}
                                  {isCustomer &&(
                                  <div className="col-md-6 mb-2 mb-md-0">
                                    <div className="d-flex justify-content-between">
                                      <span className="sub-title tc">
                                        {t("Generate Invoice")}{" "}
                                        <Tooltip
                                          content={t(
                                            "Generate_invoice_Tooltip"
                                          )}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </span>
                                      <span className="party-detail-font ">
                                        {generate_Invoice}
                                      </span>
                                    </div>
                                  </div>
                                  )}
                                  {isCustomer &&(
                                  <div className="col-md-6 mb-2 mb-md-0">                                 
                                    <div className="d-flex justify-content-between">
                                      <span className="sub-title tc">
                                        {t("Pre bill days")}{" "}
                                        <Tooltip
                                          content={t("Pre_billdays_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </span>
                                      <span className="party-detail-font ">
                                        {pre_bill_days}
                                      </span>
                                    </div>       
                                  </div>
                                  )}
                                  {party_type.includes("Customer") ?
                                    <div className="col-md-6 mb-2 mb-md-0">
                                      <div className="d-flex justify-content-between">
                                        <span className="sub-title tc">
                                          {t("ACH Payments")}{" "}
                                          <Tooltip
                                            content={t("Ach_Payments_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </span>
                                        <span className="party-detail-font ">
                                          {achPayments === true ? "Yes" : "No"}
                                        </span>
                                      </div>
                                    </div>
                                    : ""}
                                </div>
                              </div>
                              {/* <div className='row'>
                              
                            </div> */}
                            </div>
                          </div>
                        </div>
                        {customerPermission !== "Customer" && (
                          <div className="col-12 col-lg-5">
                            <div className="card">
                              <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <h5 className="mb-0">
                                    Documents ({documents.length})
                                  </h5>
                                  <button
                                    className="btn btn-primary btn-sm btn-md-normal"
                                    onClick={handleUpload}
                                  >
                                    UPLOAD
                                  </button>
                                </div>

                                <div className="documents-list">
                                  {currentDocuments &&
                                    currentDocuments.length > 0 ? (
                                    <>
                                      {currentDocuments &&
                                        currentDocuments.map((doc) => (
                                          <div
                                            className="document-item"
                                            key={doc.id}
                                          >
                                            <div className="document-icon">
                                              {doc.type === "pdf"
                                                ? "📄"
                                                : doc.type === "doc" ||
                                                  doc.type === "docx"
                                                  ? "📝"
                                                  : doc.type === "jpg" ||
                                                    doc.type === "jpeg" ||
                                                    doc.type === "png"
                                                    ? "🖼️"
                                                    : "📁"}
                                            </div>
                                            <div className="document-info">
                                              <div className="document-name">
                                                {doc.title}
                                              </div>
                                              <div className="document-metadata">
                                                {Helper.DateNormal(
                                                  doc.uploaded_at
                                                )}
                                              </div>
                                              <div className="document-tags">
                                                {doc.tags
                                                  .split(",")
                                                  .map((tag, index, arr) => (
                                                    <span
                                                      key={index}
                                                      className="tag-pill"
                                                    >
                                                      {tag.trim()}
                                                      {index < arr.length - 1
                                                        ? ", "
                                                        : ""}
                                                    </span>
                                                  ))}
                                              </div>
                                            </div>
                                            <div className="document-actions">
                                              <button
                                                className="btn-continue border-0 btn btn-primary btn-gradient-primary btn"
                                                onClick={() =>
                                                  handleDownload(doc.file)
                                                }
                                              >
                                                Download
                                              </button>
                                            </div>
                                          </div>
                                        ))}

                                      <div className="pagination-controls d-flex justify-content-between align-items-center mt-3">
                                        <button
                                          className="pag-btn btn btn-outline-secondary btn-sm"
                                          onClick={handlePrevious}
                                          disabled={currentPage === 1}
                                        >
                                          Previous
                                        </button>

                                        <span className="small">
                                          Page {currentPage} of {totalPages}
                                        </span>

                                        <button
                                          className="pag-btn btn btn-outline-secondary btn-sm"
                                          onClick={handleNext}
                                          disabled={currentPage === totalPages}
                                        >
                                          Next
                                        </button>
                                      </div>
                                    </>
                                  ) : (
                                    <div className="text-center py-4">
                                      <p className="text-muted">
                                        No documents available
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                      </div>
                      <div className="accordion-item mt-3 ">
                        <h2
                          className="accordion-header"
                          id="panelsStayOpen-headingTwo"
                        >
                          <button
                            className="accordion-button collapsed"
                            style={{ color: "#245C7F" }}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#panelsStayOpen-collapseTwo"
                            aria-expanded="false"
                            aria-controls="panelsStayOpen-collapseTwo"
                          >
                            <b>{t("Party Information")}</b>
                          </button>
                        </h2>
                        <div
                          id="panelsStayOpen-collapseTwo"
                          className="accordion-collapse collapse"
                          aria-labelledby="panelsStayOpen-headingTwo"
                        >
                          <div className="accordion-body">
                            <div className="row">
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("Tax Number")}{" "}
                                  <Tooltip content={t("TaxNumber_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {TIN_number ? TIN_number : "None"}
                                  </span>
                                </div>
                              </div>
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("Establishment Date")}{" "}
                                  <Tooltip
                                    content={t("EstablishmentDate_Tooltip")}
                                  >
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {establishment_date
                                      ? Helper.DateNormal(establishment_date)
                                      : "None"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("Sales Tax Code")}{" "}
                                  <Tooltip content={t("SalesTaxCode_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {sales_tax_code ? sales_tax_code : "None"}
                                  </span>
                                </div>
                              </div>
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("Website")}{" "}
                                  <Tooltip content={t("Website_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {website ? website : "None"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("Name")}{" "}
                                  <Tooltip content={t("Name_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {first_name ? first_name : "None"}{" "}
                                    {last_name}
                                  </span>
                                </div>
                              </div>
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("SSN / TIN Number")}{" "}
                                  <Tooltip content={t("SSN/TINNumber_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {ssn_tin_number ? ssn_tin_number : "None"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("ID Issue State")}{" "}
                                  <Tooltip content={t("IdIssueState_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {id_issue_state ? id_issue_state : "None"}
                                  </span>
                                </div>
                              </div>
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("Date of Birth")}{" "}
                                  <Tooltip content={t("DateofBirth_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {date_of_birth
                                      ? Helper.DateNormal(date_of_birth)
                                      : "None"}
                                  </span>
                                </div>
                              </div>
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("Doing BusinessAS")}{" "}
                                  <Tooltip
                                    content={t("DoingBusinessAs_Tooltip")}
                                  >
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {doingbusinessas ? doingbusinessas : "None"}
                                  </span>
                                </div>
                              </div>
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("Business Type")}{" "}
                                  <Tooltip content={t("Business_Type_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {business_type ? business_type : "None"}
                                  </span>
                                </div>
                              </div>
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("Federal ID")}{" "}
                                  <Tooltip content={t("FederalID_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {federalID ? federalID : "None"}
                                  </span>
                                </div>
                              </div>
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("SIC")}{" "}
                                  <Tooltip content={t("SIC_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {sic ? sic : "None"}
                                  </span>
                                </div>
                              </div>
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("NAICS")}{" "}
                                  <Tooltip content={t("NAICS_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {naics ? naics : "None"}
                                  </span>
                                </div>
                              </div>
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("Risk Rating")}{" "}
                                  <Tooltip content={t("RiskRating_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {riskrating ? riskrating : "None"}
                                  </span>
                                </div>
                              </div>
                              <div
                                className="col-md-6 d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <span className="sub-title tc">
                                  {t("Credit Score")}{" "}
                                  <Tooltip content={t("CreditScore_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </span>
                                <div
                                  className="col-md-6 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span className="party-detail-font ">
                                    {creditscore ? creditscore : "None"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              {extrafiledparty.map((key, index) => (
                                <>
                                  <div
                                    className={
                                      key.enable === "True"
                                        ? "col-xl-6 d-flex"
                                        : null
                                    }
                                    style={{
                                      display:
                                        key.enable === "True" ? true : "none",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <span
                                      className="sub-title tc"
                                      style={{
                                        display:
                                          key.enable === "True" ? true : "none",
                                      }}
                                    >
                                      {key.label}
                                    </span>
                                    <div
                                      className={
                                        key.enable === "True"
                                          ? "col-xl-6 d-flex"
                                          : null
                                      }
                                      style={{
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <span
                                        className="party-detail-font "
                                        style={{
                                          display:
                                            key.enable === "True"
                                              ? true
                                              : "none",
                                        }}
                                      >
                                        {attribute[index]["attribute"]
                                          ? attribute[index]["attribute"]
                                          : "None"}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              {party_type.includes("Customer") ? (
                // achPayments === true ?
                <>
                  <TabPanel>
                    <div
                      className="panel-content pa-co"
                      style={{ paddingLeft: "10px" }}
                    >
                      {/* <ContractList id={state} /> */}
                      {/* <div className='pt-4'> */}

                      <AchIndex
                        id={state}
                        setHideShowAchIndex={setHideShowAchIndex}
                        setHideShowAchEdit={setHideShowAchEdit}
                        hideShowachindex={hideShowachindex}
                        hideShowachedit={hideShowachedit}
                        setHideShowAchID={setHideShowAchID}
                      />
                      {/* </div> */}
                      {hideShowachindex && (
                        <div className="pt-4" ref={addfromAch}>
                          <AddAchAccounts
                            id={state}
                            setHideShowAchIndex={setHideShowAchIndex}
                            setACHId={setACHId}
                          />
                        </div>
                      )}
                      {hideShowachedit && (
                        <div className="pt-4" ref={editformAch}>
                          <EditAchAccount
                            id={state}
                            hideShowachId={hideShowachId}
                            setHideShowAchEdit={setHideShowAchEdit}
                          />
                        </div>
                      )}
                    </div>
                  </TabPanel>
                </>
              )
                : ""
              }
              {/* </>
              // :""):""} */}
              <TabPanel>
                <div
                  className="panel-content pa-co"
                  style={{ paddingLeft: "10px" }}
                >
                  <PartyShortdetilview id={state} setTab={setTabIndex} />
                  <div className="pt-4">
                    <AddresstList id={state} />
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div
                  className="panel-content pa-co"
                  style={{ paddingLeft: "10px" }}
                >
                  <PartyShortdetilview id={state} setTab={setTabIndex} />
                  <div className="pt-4">
                    <ContactList
                      id={state}
                      setHideShowParyContact={setHideShowParyContact}
                      setHideShowParyContactEdit={setHideShowParyContactEdit}
                      setContactId={setContactId}
                      hideShowParyContact={hideShowParyContact}
                      hideShowParyContactEdit={hideShowParyContactEdit}
                    />
                  </div>
                  {hideShowParyContact && (
                    <div className="pt-4" ref={addfromcontract}>
                      <Partycontact
                        id={state}
                        setHideShowParyContact={setHideShowParyContact}
                      />
                    </div>
                  )}
                  {hideShowParyContactEdit && contactId && (
                    <div className="pt-4" ref={editformcontract}>
                      <ContactEdit
                        id={state}
                        contact={contactId}
                        setHideShowParyContactEdit={setHideShowParyContactEdit}
                      />
                    </div>
                  )}
                </div>
              </TabPanel>
              <TabPanel>
                <div
                  className="panel-content pa-co"
                  style={{ paddingLeft: "10px" }}
                >
                  <PartyShortdetilview id={state} setTab={setTabIndex} />
                  <div className="pt-4">
                    <ManageNotification
                      id={state}
                      setHideShowNotify={setHideShowNotify}
                      setHideShowNotifyEdit={setHideShowNotifyEdit}
                      hideShowNotify={hideShowNotify}
                      hideShowNotifyEdit={hideShowNotifyEdit}
                      setNotifyId={setNotifyId}
                    />
                  </div>
                  {hideShowNotify && (
                    <div className="pt-4" ref={addFormRef}>
                      <AddNotification
                        id={state}
                        setHideShowNotify={setHideShowNotify}
                      />
                    </div>
                  )}
                  {hideShowNotifyEdit && (
                    <div className="pt-4" ref={editFormRef}>
                      <EditNotification
                        id={state}
                        notification={notifyId}
                        setHideShowNotifyEdit={setHideShowNotifyEdit}
                      />
                    </div>
                  )}
                </div>
              </TabPanel>
              <TabPanel>
                <div
                  className="panel-content pa-co"
                  style={{ paddingLeft: "10px" }}
                >
                  <ContractList id={state} />
                </div>
              </TabPanel>

            </Tabs>
          </>
        ) : (
          <ContentLoader
            viewBox="0 0 400 160"
            backgroundColor="rgba(0,0,0,0.06)"
            foregroundColor="rgba(0,0,0,0.12)"
          >
            <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
            <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
            <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
            <rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
            <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
            <rect x="0" y="99" rx="5" ry="5" width="400" height="200" />
          </ContentLoader>
        )}
      </div>
    </>
  );
}

export default PartyDetails;